import { useNavigate } from 'react-router-dom';

import { useDocumentShare } from 'lib/hooks/useDocumentShare';
import { downloadCheckinInvoicePdf } from 'lib/helpers/pdf/download/download';

import Modal from 'components/shared/Modal/Modal';
import DocumentZoomToggle from 'components/shared/DocumentSheet/components/DocumentZoomToggle';
import { DocumentZoomProvider } from 'components/shared/DocumentSheet/lib/documentZoomContext';
import DocumentShareActions from 'components/shared/DocumentSheet/components/DocumentShareActions';
import { useDocumentPractice } from 'components/Patient/checkin/SecurePayment/lib/useDocumentPractice';
import InvoiceDocument from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceDocument/InvoiceDocument';

const CheckinPreviewInvoice = ({ isOpen, onClose, invoice, practice, surchargeAmount = 0 }) => {
  const navigate = useNavigate();
  const documentPractice = useDocumentPractice({ practice, enabled: isOpen });

  // There's no patient-facing endpoint to email or text an appointment invoice, so this sheet
  // offers Download only.
  const { busy, handleDownload } = useDocumentShare({
    noun: 'invoice',
    downloadRequest: () =>
      downloadCheckinInvoicePdf({ navigate, appointmentId: invoice?.appointment_id })
  });

  return (
    <DocumentZoomProvider>
      <Modal
        className="xs:!rounded-none"
        isOpen={isOpen}
        title={`Invoice #${invoice?.id}`}
        width="large"
        headButton={
          <div className="flex w-full items-center justify-end gap-2 pr-3">
            <DocumentZoomToggle />
            <DocumentShareActions busy={busy} onDownload={handleDownload} canSend={false} />
          </div>
        }
        handleClose={onClose}
        bodyClassName="p-0 bg-neutral-100 overflow-auto"
        isFooter={false}
        headerClassName="bg-white border-b border-neutral-200 border-solid border-0 px-4 py-3 gap-2"
        overlayClassName="xs:!p-0">
        <div className="flex w-full justify-center py-6 print:py-0">
          <InvoiceDocument
            invoice={invoice}
            practice={documentPractice}
            surcharge={surchargeAmount}
          />
        </div>
      </Modal>
    </DocumentZoomProvider>
  );
};

export default CheckinPreviewInvoice;
